import { get, destroy, post, put } from 'app/shared/utils/fetchr';

import {
  BulkCreateCustomDataSettingsResponse,
  OrgDataSettingsConfigAddEditResponse,
  OrgDataSettingsConfigResponse,
} from 'app/modules/dataSettings/responses';
import {
  BulkAddOrgCustomDataSettingsRequestPayload,
  EditDataSettingsConfigRequest,
} from 'app/modules/dataSettings/requests';

export const getDataSettings = (): Promise<OrgDataSettingsConfigResponse> =>
  get('/v1/data/settings/list');

export const deleteOrgCustomDataSettingsConfig = (
  id: number,
): Promise<Record<string, never>> =>
  destroy(`/v1/custom_data/settings/${id}/delete`);

export const addOrgCustomDataSettingsConfig = (
  payload: BulkAddOrgCustomDataSettingsRequestPayload,
): Promise<BulkCreateCustomDataSettingsResponse> =>
  post('/v1/custom_data/settings/create', payload);

export const editDataSetting = (
  id: number,
  payload: EditDataSettingsConfigRequest,
): Promise<OrgDataSettingsConfigAddEditResponse> =>
  put(`/v1/data/settings/${id}/edit`, payload);
